import * as ActionTypes from '../actions/PhotographerUploadActionTypes';
import InitialState from './PhotographerUploadInitialState';
import { assign } from '../../../shared/Assign';
import { IFailedOrder, IFailedOrderRow, IFailedPicture } from '../Entities';

export default function photographerUploadReducer(
    state: any = InitialState.photographerUpload,
    action: { type: string; result: any }
) {
    switch (action.type) {
        case ActionTypes.LIST_PHOTOGRAPHER_UPLOAD_SUCCESS: {
            const newState = assign({}, state);
            newState.list = action.result;
            return newState;
        }
        case ActionTypes.SAVE_PHOTOGRAPHER_UPLOAD_METADATA_SUCCESS: {
            const newState = assign({}, state);
            newState.metadata.saved = true;
            newState.metadata.idList = action.result;
            return newState;
        }

        default:
            return state;
    }
}
